import * as React from 'react';
import classes from './ErrorLayout.module.scss';
import classnames from 'classnames';

export interface ELProps {
  title: string;
  message: React.ReactNode;
  image: React.ReactNode;
}

export class ErrorLayout extends React.Component<ELProps> {
  render() {
    const { title, message, image } = this.props;
    return (
      <div className={classes.container}>
        <div className={classes.image}>{image}</div>
        <h6 className={classnames('headline-6', classes.title)}>{title}</h6>
        <div className={classes.message}>{message}</div>
      </div>
    );
  }
}
